import {Module} from 'vuex';
import {DynamicFormType} from '@/support-forms/supportFormModel';
import {getDynamicFormTypes} from '@/support-forms/supportFormService';

interface SupportFormState {
    types: DynamicFormType[];
}

export default {
    namespaced: true,
    state: {
        types: []
    },
    actions: {
        async loadReferenceData({commit}): Promise<void> {
            const types = await getDynamicFormTypes();
            commit('setTypes', types);
        }
    },
    mutations: {
        setTypes(state, payload: DynamicFormType[]) {
            state.types = payload;
        }
    },
} as Module<SupportFormState, any>;
